import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export default function EditableField({
  component,
  id,
  isEditing,
  label,
  multiline,
  onChange,
  text,
  sx,
  variant,
  value = "",
}) {
  return (
    <Box display="flex" flexDirection="column" sx={{ whiteSpace: "pre-wrap" }}>
      {isEditing ? (
        <TextField
          id={id}
          label={label}
          margin="dense"
          multiline={multiline}
          onChange={onChange}
          size="small"
          sx={{
            "& .MuiFilledInput-root": {
              backgroundColor: "backgroundContrast.main",
            },
            "& .MuiInputBase": {
              backgroundColor: "backgroundContrast.main",
            },
          }}
          value={value}
          variant="filled"
        />
      ) : (
        text && (
          <Typography id={id} component={component} sx={sx} variant={variant}>
            {text}
          </Typography>
        )
      )}
    </Box>
  );
}
